import { render, staticRenderFns } from "./BaseTopBtn.vue?vue&type=template&id=0f0f5acd&"
import script from "./BaseTopBtn.vue?vue&type=script&lang=js&"
export * from "./BaseTopBtn.vue?vue&type=script&lang=js&"
import style0 from "./BaseTopBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports